module.exports = __webpack_public_path__ + "media/images/athletes/1105-efd12c889b724475736d3d0474d98b51.png";